import { render, staticRenderFns } from "./Ylsfj2.vue?vue&type=template&id=7ffe5c1f&scoped=true"
import script from "./Ylsfj2.vue?vue&type=script&lang=js"
export * from "./Ylsfj2.vue?vue&type=script&lang=js"
import style0 from "./Ylsfj2.vue?vue&type=style&index=0&id=7ffe5c1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffe5c1f",
  null
  
)

export default component.exports